import axios from 'axios'
//import Cookies from 'universal-cookie'
import { CleanJsonData } from '../Utilities/Utilities.js'
// import { window.API_BASE_URL } from '../config.js';
import Cookies from 'universal-cookie'

//const
const data = {
    messages: { success: true, message: "", list: [] },
}

const UPDATE_MESSAGE = 'UPDATE_MESSAGE'
const CREATE_MESSAGE = 'CREATE_MESSAGE'
const GET_MESSAGES = 'GET_MESSAGES_LIST'
const DELETE_MESSAGE = 'DELETE_MESSAGE'
const GET_FULL_CLIENT_MESSAGES = 'GET_FULL_CLIENT_MESSAGES';
const GET_CONVERSATION_MESSAGES_ONLY = 'GET_CONVERSATION_MESSAGES_ONLY';

// reducer
export default function messageReducer(state = data, action) {
    switch (action.type) {
        case GET_MESSAGES:
            return { ...state, messages: action.payload }
        case CREATE_MESSAGE:
            return { ...state, messages: action.payload }
        case DELETE_MESSAGE:
            return { ...state }
        case GET_FULL_CLIENT_MESSAGES:
            return { ...state, messages: action.payload }
        case GET_CONVERSATION_MESSAGES_ONLY:
            return { ...state, messages: action.payload }
            default:
            return state
        }
}

export const GetListMessages = (DATA) => async (dispatch) => {

    // const cookies = new Cookies()
    DATA = CleanJsonData(DATA)

    dispatch({
        type: GET_MESSAGES,
        payload: { success: false, message: window.messagesAxios.messageStart, list: [] }
    })

    try { 
        var RES
        if (DATA === "0") {
        RES = await axios.get(window.API_BASE_URL+'/Messages/Responses')
    
        } else { 
            RES = await axios.get(window.API_BASE_URL+'/Messages/Responses/BusinessLine/'+DATA)
        }   
        //console.log(RES)
        if(RES.status === 200 ){
            dispatch({
                type: GET_MESSAGES,
                payload: { success: false, message: window.messagesAxios.messageSuccess, list: RES.data }
            })
        }
        else {
            dispatch({
                type: GET_MESSAGES,
                payload: { success: false, message: window.messagesAxios.messageError, list: [] }
            })
        }

    } catch (error) {
        if (error.response.status === 404) {
            dispatch({
                type: GET_MESSAGES,
                payload: { success: false, message: error.response.data, list: [] }
            })
        }
        else {
            dispatch({
                type: GET_MESSAGES,
                payload: { success: false, message: window.messagesAxios.messageError, user: null }
            })
        }
    }
}

export const CreateMessage = (DATA) => async (dispatch, getState) => {

    //const cookies = new Cookies()
    //DATA = CleanJsonData(DATA)
    var messages = getState().message.messages.list 
    dispatch({
        type: CREATE_MESSAGE,
        payload: { success: false, message: window.messagesAxios.messageStart, list: [] }
    })

    try { 
        const RES = await axios.post(window.API_BASE_URL+'/Messages/Responses',DATA)
        if(RES.status === 200 ){
            messages.push(RES.data)
            dispatch({
                type: CREATE_MESSAGE,
                payload: { success: true, message: window.messagesAxios.messageSuccess, list: messages }
            })
        }
        else {
            dispatch({
                type: CREATE_MESSAGE,
                payload: { success: false, message: window.messagesAxios.messageError, list: [] }
            })
        }

    } catch (error) {
        if (error.response.status === 404) {
            dispatch({
                type: CREATE_MESSAGE,
                payload: { success: false, message: error.response.data, list: [] }
            })
        }
        else {
            dispatch({
                type: CREATE_MESSAGE,
                payload: { success: false, message: window.messagesAxios.messageError, list: [] }
            })
        }
    }
}

export const UpdateMessage = (DATA) => async (dispatch, getState) => {

    //const cookies = new Cookies()
    //DATA = CleanJsonData(DATA)
    var messages = getState().message.messages.list
    dispatch({
        type: UPDATE_MESSAGE,
        payload: { success: false, message: window.messagesAxios.messageStart, list: [] }
    })

    try { 
        const RES = await axios.put(window.API_BASE_URL+'/Messages/Responses',DATA)
        if(RES.status === 200 ){
            //messages.push(RES.data actualizar)
            const index = messages.findIndex(message => message.id === DATA.id);
            if (index !== -1) {
                messages[index] = RES.data;
            }
            dispatch({
                type: UPDATE_MESSAGE,
                payload: { success: true, message: window.messagesAxios.messageSuccess, list: messages }
            })
        }
        else {
            dispatch({
                type: UPDATE_MESSAGE,
                payload: { success: false, message: window.messagesAxios.messageError, list: [] }
            })
        }

    } catch (error) {
        if (error.response.status === 404) {
            dispatch({
                type: UPDATE_MESSAGE,
                payload: { success: false, message: error.response.data, item: null }
            })
        }
        else {
            dispatch({
                type: UPDATE_MESSAGE,
                payload: { success: false, message: window.messagesAxios.messageError, item: null }
            })
        }
    }
}

export const DeleteMessage = (id) => async (dispatch) => {

    dispatch({
        type: DELETE_MESSAGE,
        payload: { success: false, message: window.messagesAxios.messageStart, item: null }
    })

    try { 
        const RES = await axios.delete(`${window.API_BASE_URL}/Messages/Responses/${id}`)
        if(RES.status === 200 ){
            dispatch({
                type: DELETE_MESSAGE,
                payload: { success: false, message: window.messagesAxios.messageSuccess, item: RES.data }
            })
        }
        else {
            dispatch({
                type: DELETE_MESSAGE,
                payload: { success: false, message: window.messagesAxios.messageError, item: null }
            })
        }

    } catch (error) {
        if (error.response.status === 404) {
            dispatch({
                type: DELETE_MESSAGE,
                payload: { success: false, message: error.response.data, item: null }
            })
        }
        else {
            dispatch({
                type: DELETE_MESSAGE,
                payload: { success: false, message: window.messagesAxios.messageError, item: null }
            })
        }
    }
}


export const GetFullClientMessages = (clientId) => async (dispatch) => {
    dispatch({
        type: GET_FULL_CLIENT_MESSAGES,
        payload: { success: false, message: 'Cargando mensajes...', list: [] }
    });

    try {
        const RES = await axios.get(`${window.API_BASE_URL}/Conversations/get-all-messages-by-client?clientId=${clientId}`);
        if (RES.status === 200) {
            dispatch({
                type: GET_FULL_CLIENT_MESSAGES,
                payload: { success: true, message: 'Mensajes cargados correctamente', list: RES.data }
            });
        } else {
            dispatch({
                type: GET_FULL_CLIENT_MESSAGES,
                payload: { success: false, message: 'Error al cargar los mensajes', list: [] }
            });
        }
    } catch (error) {
        dispatch({
            type: GET_FULL_CLIENT_MESSAGES,
            payload: { success: false, message: 'Error al cargar los mensajes', list: [] }
        });
    }
};

export const GetConversationMessagesOnly = (conversationId) => async (dispatch) => {
    dispatch({
        type: GET_CONVERSATION_MESSAGES_ONLY,
        payload: { success: false, message: 'Cargando mensajes...', list: [] }
    });

    try {
        const cookies = new Cookies();
        const RES = await axios.get(`${window.API_BASE_URL}/Conversations/ConversationMessaging/${conversationId}`, {
            headers: { 'Authorization': `Bearer ${cookies.get('token')}` }
        });

        if (RES.status === 200) {
            dispatch({
                type: GET_CONVERSATION_MESSAGES_ONLY,
                payload: { success: true, message: 'Mensajes cargados correctamente', list: RES.data }
            });
        } else {
            dispatch({
                type: GET_CONVERSATION_MESSAGES_ONLY,
                payload: { success: false, message: 'Error al cargar los mensajes', list: [] }
            });
        }
    } catch (error) {
        dispatch({
            type: GET_CONVERSATION_MESSAGES_ONLY,
            payload: { success: false, message: 'Error al cargar los mensajes', list: [] }
        });
    }
};
